module.exports = __webpack_public_path__ + "static/france-ef0fcdd39980fa7680681e9816d20a74.jpg";